let counter = 0;
export default (referenceId) => {
	counter += 1;
	return `uid_${referenceId}_${counter}`;
};
